import styled from 'src/lib/styles/css';

//#region [Styles]
const STextListContainer = styled.section`
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin: 15px 0;
`;

export default STextListContainer;
//#endregion